// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { ToastContainer } from 'react-toastify';
import { ConfigProvider, Spin } from 'antd';
import { ModernSpinner } from 'components/ModernLoader';

// Set a clean global spinner for all <Spin> and <Table loading> across the app
Spin.setDefaultIndicator(
  <span className="anticon" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    <ModernSpinner size={32} />
  </span>
);

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <ThemeCustomization>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#D50F2B',
          colorPrimaryHover: '#E8002B',
          colorPrimaryActive: '#B00022',
          borderRadius: 6,
        },
      }}
    >
      <ScrollTop>
        <Routes />
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </ScrollTop>
    </ConfigProvider>
  </ThemeCustomization>
);

export default App;

